import mqtt from 'mqtt'
import { buildMqttUrl } from '@/config/mqtt'

let client = null
let currentAdminId = null
let currentClientId = null
const alarmPopupListeners = new Set()

/** 后端允许 "{admin_id}" 或 "{admin_id}-{后缀}"，每页独立后缀避免多端互踢 */
function buildMqttClientId(adminId) {
  const suffix = Math.random().toString(36).slice(2, 8)
  return `${adminId}-${suffix}`
}

function emitAlarmPopup(data) {
  alarmPopupListeners.forEach(fn => {
    try {
      fn(data)
    } catch (e) {
      console.warn('[MQTT上报信息:] alarm popup listener error', e)
    }
  })
}

function parseMessage(payload) {
  const text = payload && typeof payload.toString === 'function' ? payload.toString() : ''
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch (e) {
    console.warn('[MQTT上报信息:] invalid JSON message', text)
    return null
  }
}

export function onAlarmPopup(callback) {
  alarmPopupListeners.add(callback)
  return () => alarmPopupListeners.delete(callback)
}

export function connectMqtt({ adminId, token }) {
  const id = Number(adminId)
  if (!Number.isFinite(id) || id <= 0 || !token) return

  if (client && currentAdminId === id && client.connected) return

  disconnectMqtt()
  currentAdminId = id
  currentClientId = buildMqttClientId(id)

  const url = buildMqttUrl()
  if (process.env.NODE_ENV === 'development') {
    console.info('[MQTT上报信息:] connecting', url, 'clientId:', currentClientId)
  }

  client = mqtt.connect(url, {
    username: 'admin',
    clientId: currentClientId,
    password: token,
    clean: true,
    keepalive: 45,
    reconnectPeriod: 2000,
    protocolVersion: 5
  })

  client.on('connect', () => {
    if (process.env.NODE_ENV === 'development') {
      console.info('[MQTT上报信息:] connected, subscribing admin/' + id + '/down')
    }
    client.subscribe(`admin/${id}/down`, { qos: 1 }, err => {
      if (err) console.warn('[MQTT上报信息:] subscribe failed', err)
    })
  })

  client.on('message', (topic, payload) => {
    const msg = parseMessage(payload)
    if (!msg) return

    console.log('[MQTT上报信息:] message', { topic, data: msg })

    if (msg.cmd !== 'alarmPopup' || !msg.data) return
    emitAlarmPopup(msg.data)
  })

  client.on('error', err => {
    console.warn('[MQTT上报信息:] connection error', err)
  })

  client.on('close', () => {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[MQTT上报信息:] connection closed')
    }
  })
}

export function disconnectMqtt() {
  currentAdminId = null
  currentClientId = null
  if (!client) return
  try {
    client.end(true)
  } catch (e) {
    console.warn('[MQTT上报信息:] disconnect error', e)
  }
  client = null
}
